import angular from 'angular';

(function() {
    'use strict';

    /**
     * Composant permettant la sélection d'une date min et max. La date min ne peut pas être supérieur à la date max.
     */
    angular.module('app.core').component('kissDateBetween', {
        bindings: {
            dateFrom: '=', // Date début sélectionnée
            dateTo: '=', // Date fin sélectionnée
            dateMax: '@', // Date max
            fromLabel: '@', // Label du champ date début
            toLabel: '@' // Label du champ date fin (optionnel)
        },
        controller: DateBetweenController,
        templateUrl: require('./date-between.html')
    });

    DateBetweenController.$inject = [];

    function DateBetweenController() {
        var ctrl = this;

        ctrl.randomId = Math.random();

        ctrl.$onInit = function() {
            if (!ctrl.toLabel) {
                ctrl.toLabel = 'commons.and';
            }
        };
    }
})();
